import React, { useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import Seleccionarempleat from "./Seleccionarempleat";
import Detallsempleat from "./Detallsempleat";
import GestioEmpleat from "./GestioEmpleat";
import "../dashboard_v2.css";
import AjudaEntitats from "./AjudaEntitats";
import { BotoAjuda } from "./AjudaModal";

function idEmpleat(e) {
  return e ? Number(e.idEmpleats) : null;
}

function PestanyesEmpleat({ active, onChange, pucGestio }) {
  return (
    <nav className="dv2-subnav" aria-label="Seccions de l'empleat">
      <button
        type="button"
        className={`dv2-subnav-btn ${active === "dades" ? "is-active" : ""}`}
        onClick={() => onChange("dades")}
      >
        Dades
      </button>
      {pucGestio && (
        <button
          type="button"
          className={`dv2-subnav-btn ${active === "gestio" ? "is-active" : ""}`}
          onClick={() => onChange("gestio")}
        >
          Gestió
        </button>
      )}
    </nav>
  );
}

function Empleats() {
  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selectedEmpleat, setSelectedEmpleat] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [empleatsList, setEmpleatsList] = useState([]);
  const [reloadToken, setReloadToken] = useState(0);

  const { rolUsuari } = useUserContext();
  const pucGestio = tincPermis(rolUsuari, "ACCES", "EMPLEATS");
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleEmpleatSelect = (empleat) => {
    if (!empleat) {
      setSelectedEmpleat(null);
      return;
    }
    setSelectedEmpleat((prev) => (idEmpleat(prev) === idEmpleat(empleat) ? null : empleat));
  };

  const obrirFitxa = (empleat, mode) => {
    setSelectedEmpleat(empleat);
    setActiveTab(mode);
  };

  const canviarSeccio = (seccio) => {
    if (seccio === "dades") {
      setActiveTab("consultar");
      return;
    }
    setActiveTab(seccio);
  };

  const esLlista = activeTab === "seleccionar";
  const mostraPestanyes = selectedEmpleat && !["nou", "esborrar"].includes(activeTab);
  const seccioActiva = activeTab === "gestio" ? "gestio" : "dades";
  const subnav = mostraPestanyes ? (
    <PestanyesEmpleat active={seccioActiva} onChange={canviarSeccio} pucGestio={pucGestio} />
  ) : null;

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaEntitats pestanya="empleats" onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                👷
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">Empleats</h1>
                <p className="dv2-pageHeader-subtitle">Fitxa de l'empleat i gestió laboral.</p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title="Com funcionen els Empleats" onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelectedEmpleat(null);
                    setActiveTab("nou");
                  }}
                >
                  Nou empleat
                </button>
              )}
            </div>
          </div>

          <Seleccionarempleat
            onEmpleatSelect={handleEmpleatSelect}
            onConsultar={(e) => obrirFitxa(e, "consultar")}
            onModificar={(e) => obrirFitxa(e, "modificar")}
            onEsborrar={(e) => obrirFitxa(e, "esborrar")}
            onGestio={pucGestio ? (e) => obrirFitxa(e, "gestio") : undefined}
            selectedEmpleat={selectedEmpleat}
            filterText={filterText}
            setFilterText={setFilterText}
            setEmpleatsLlista={setEmpleatsList}
            reloadToken={reloadToken}
          />
        </>
      ) : activeTab === "gestio" ? (
        <GestioEmpleat
          empleatProp={selectedEmpleat}
          subnav={subnav}
          empleats={empleatsList}
          onNavigate={setSelectedEmpleat}
          onTornar={() => tornarLlista(false)}
        />
      ) : (
        <Detallsempleat
          mode={activeTab}
          empleat={activeTab === "nou" ? null : selectedEmpleat}
          empleats={empleatsList}
          subnav={subnav}
          onNavigate={setSelectedEmpleat}
          onCancel={() => tornarLlista(false)}
          onDeleted={() => tornarLlista(true)}
          onCanviarMode={(modeNou) => setActiveTab(modeNou)}
          onSave={(updated) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelectedEmpleat(updated);
            setEmpleatsList((prev) =>
              (prev || []).map((e) => (idEmpleat(e) === idEmpleat(updated) ? { ...e, ...updated } : e))
            );
            setActiveTab("consultar");
          }}
        />
      )}
    </div>
  );
}

export default Empleats;
